import * as React from "react"
import type { SVGProps } from "react"
const SvgTag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.15 22.43a2 2 0 0 1-1.43-.6l-7.15-7.15q-.3-.3-.43-.66a2 2 0 0 1 0-1.5q.13-.37.43-.67l7.8-7.82q.28-.28.66-.44a2 2 0 0 1 .77-.16h7.18q.83 0 1.4.59.6.59.6 1.4v7.18a2 2 0 0 1-.58 1.4l-7.82 7.83a2 2 0 0 1-1.43.6m0-2 7.83-7.85V5.43h-7.15L4 13.28zm4.33-10q.62 0 1.06-.44.44-.45.44-1.06 0-.63-.44-1.06a1.5 1.5 0 0 0-1.06-.44q-.62 0-1.07.44a1.5 1.5 0 0 0-.43 1.06q0 .62.43 1.06.45.45 1.07.44" />
  </svg>
)
export default SvgTag
